import { Utilites } from './../Utilities';

export class Validation {
    constructor(form, options = {}) {
        this.debug = options.debug || false;
        this.exception = false;
        this.invalids = [];

        this.utilities = new Utilites(this.debug);

        try {
            if (! form) {
                throw "form object required";
            }

            if (! form.tagName) {
                throw "object doesn't contain tagName property";
            }

            if (form.tagName !== 'FORM') {
                throw "invalid form object";
            }
        } catch(exception) {
            this.utilities.log(exception, 'Validation.constructor');
            this.exception = true;
            return;
        }

        this.form = form;
        this.inputs = this.utilities.querySelectorAll(
            form,
            ['input:not([type="hidden"]):not([type="radio"])','textarea','select']
        );
        this.radiosAndCheckboxes = this.utilities.querySelectorAll(
            form,
            ['input[type="radio"]', 'input[type="checkbox"]']
        );

        this._bindEvents();
    }

    _updateInputFeedback(input, valid = false, type = "text") {
        let add = 'is-invalid',
            remove = 'is-valid';

        if (valid === true) {
            add = 'is-valid';
            remove = 'is-invalid';
        }

        let target = input.parentNode;
        if (type === "radioAndCheckbox") {
            target = input.parentNode.parentNode.parentNode;
        }

        target.classList.add(add);
        target.classList.remove(remove);
    }

    _updateInvalids(name, valid) {
        const index = this.invalids.indexOf(name);

        if (valid === true) {
            if (index > -1) {
                this.invalids.splice(index, 1);
                this.utilities.log(`removing ${name} from invalids`, 'Validation._updateInvalid');
            }
        } else {
            if (index < 0) {
                this.invalids.push(name);
                this.utilities.log(`adding ${name} to invalids`, 'Validation._updateInvalids');
            }
        }
    }

    _validate(input) {
        if (input.required === true) {
            const validAttribute = input.getAttribute('data-valid');
            let valid = false;

            // check for data-valid attribute, if present use that value for validation
            if (validAttribute !== null) {
                valid = validAttribute === 'true';
            } else {
                const pattern = this._getPattern(input);
                valid = pattern.test(input.value);
            }

            this._updateInvalids(input.name, valid);
            this._updateInputFeedback(input, valid);
        }
    }

    _validateRadiosAndCheckboxes(input, minimum = 1, maximum = false) {
        let checked = 0;
        const inputs = this.utilities.querySelectorAll(document, `input[name="${input.name}"]`);

        Array.from(inputs, (input) => {
            if (input.checked === true) {
                checked++;
            }
        });

        const valid = ((checked, minimum, maximum) => {
            if (maximum !== false) {
                if (checked > maximum) {
                    return false;
                }
            }

            if (checked < minimum) {
                return false;
            }

            return true;
        })(checked, minimum, maximum);

        if (input.required === true) {
            this._updateInvalids(input.name, valid);
            this._updateInputFeedback(input, valid, 'radioAndCheckbox');
        }
    }

    _run() {
        const inputs = this.inputs;
        const radiosAndCheckboxes = this.radiosAndCheckboxes;
        const exception = this.exception;

        if (exception === false) {
            Array.from(inputs, (input) => {
                this._validate(input);
            });

            Array.from(radiosAndCheckboxes, (input) => {
                this._validateRadiosAndCheckboxes(input);
            });
        }

        this.utilities.log(this.invalids, 'Validation._run');
        return this.invalids.length === 0;
    }


    _bindEvents() {
        Array.from(this.inputs, (input) => {
            input.addEventListener('blur', (event) => {
                const input = event.target;
                this._validate(input);
            });
        });

        Array.from(this.radiosAndCheckboxes, (input) => {
            const fn = (event) => {
                const input = event.target;
                this._validateRadiosAndCheckboxes(input);
            };

            input.addEventListener('blur', fn);
            input.addEventListener('change', fn);
        });

        // disable html5 validation
        this.form.setAttribute("novalidate", "novalidate");

        //submit
        this.form.addEventListener('submit', (event) => {
            if (this._run() === false) {
                event.preventDefault();
                return false;
            }
            return true;
        });
    }

    _getPattern(input) {
        const patterns = {
            alpha: /(^[a-zA-Z',.\-\ @]+$)/,
            alphaNum: /(^[a-zA-Z0-9'\-\.,#:&\!\?\(\)\s]+$)/,
            title: /(^[a-zA-Z0-9'\-\.,:\(\)\s]+$)/,
            num: /(^-?\d\d*\.\d*$)|(^-?\d\d*$)|(^-?\.\d\d*$)/,
            zip: /(^\d{5,9}$)|(^\d{5}-\d{4}$)/,
            digit2: /(\d{2})/,
            digit3: /(\d{3})/,
            digit4: /(\d{4})/,
            digit5: /(\d{5})/,
            digit7: /(\d{7})/,
            max2: /(^[0-9]{1,2})$/,
            max4: /(^[0-9]{1,4})$/,
            year: /(^(19|20)[0-9]{2})$/,
            ssn: /(^[0-9]{3}(-)?[0-9]{2}(-)?[0-9]{4})$/,
            phone: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
            email: /^[a-z0-9&]([a-z0-9_\-\.'&+]*)@([a-z0-9_\-\.]*)(\.[a-z]{2,6}(\.[a-z]{2}){0,2})$/i,
            url: /^(([http|https]+):)(\/{2})([0-9.\-A-Za-z]+)\.([0-9.\-A-Za-z]+)\.([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/,
            filn: /^(\D{1})(\s+|\.{1}\s+)(\D+)$/,
            tax: /^(\d{2})(-?)(\d{7})$/,
            date: /^(Jan|January|Feb|February|Mar|March|Apr|April|May|Jun|June|Jul|July|Aug|August|Sep|September|Oct|October|Nov|November|Dec|December|(0?\d{1})|(10|11|12))(-|\s|\/|\.)(0?[1-9]|(1|2)[0-9]|3(0|1))(-|\s|\/|\.|,\s)(19|20)?\d\d$/i,
            notEmpty: /.+/
        }

        const dataPattern = input.getAttribute('data-pattern') || 'alphaNum';
        const pattern = patterns[dataPattern] || patterns['alphaNum'];

        return pattern;
    };
};



// WEBPACK FOOTER //
// ./src/modules/Shared/Validation/index.js